import React, { useEffect } from 'react';

import { useCognito } from '../../../providers/cognito';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useErrorHandler } from '@sandtech-hub-monorepo/ui-kit';

const COGNITO_ERRORS = {
  errorPrefix: 'PreSignUp failed with error ',
};

export const OAuthToken: React.FC<{
  homeRoute: string;
  loginRoute: string;
  welcomeText?: string;
}> = ({ homeRoute, loginRoute, welcomeText = 'Welcome to the eHub.' }) => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const { handleAuthError } = useErrorHandler();
  const { currentUser, socialSignIn } = useCognito();

  useEffect(() => {
    if (currentUser) {
      navigate(homeRoute);
    }
  }, [currentUser, homeRoute, navigate]);

  const error = params.get('error_description');

  useEffect(() => {
    if (error) {
      handleAuthError(error.replace(COGNITO_ERRORS.errorPrefix, ''));
      navigate(loginRoute);
    }
  }, [error, handleAuthError, loginRoute, navigate, socialSignIn]);

  return (
    <div className="h-screen mx-auto w-1/2 flex flex-col gap-4 items-center justify-center bg-background">
      <h1 className="text-[7rem] font-bold leading-tight bg-gradient-to-r from-gradient-start to-gradient-stop bg-clip-text text-transparent">
        Hi!
      </h1>
      <span className="font-semibold text-xl sm:text-2xl lg:text-4xl  w-max bg-gradient-to-r from-gradient-start to-gradient-stop bg-clip-text text-transparent">
        {welcomeText}
      </span>
      <span className="text-sm sm:text-base text-muted-foreground text-center">
        We are setting up your profile <br />
        this might take a while.
      </span>
    </div>
  );
};
